<template>
<v-layout>
    <v-flex>
        <v-tabs
        v-model="tab"
        slider-color="secondary"
        fixed-tabs
        grow
        >
            <v-tab ripple href="#tamanhos">
                Tamanhos
            </v-tab>
            <v-divider vertical inset class="grey darken-1"></v-divider>
            <v-tab ripple href="#massas">
                Massas
            </v-tab>
            <v-divider vertical inset class="grey darken-1"></v-divider>
            <v-tab ripple href="#bordas">
                Bordas
            </v-tab>
            <v-divider vertical inset class="grey darken-1"></v-divider>
            <v-tab ripple href="#sabores">
                Sabores
            </v-tab>
            <v-divider vertical inset class="grey darken-1"></v-divider>
            <v-tab ripple href="#configuracao">
                Configuração
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="tamanhos">
                <v-container>
                    <v-layout>
                        <v-flex>
                            <sp-pizza-size :sizes-data="pizza.tamanhos"></sp-pizza-size>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
            <v-tab-item value="massas">
                <v-container>
                    <v-layout>
                        <v-flex>
                            <sp-pizza-dough :doughs-data="pizza.massas"></sp-pizza-dough>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
            <v-tab-item value="bordas">
                <v-container>
                    <v-layout>
                        <v-flex>
                            <sp-pizza-edge :edges-data="pizza.bordas"></sp-pizza-edge>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
            <v-tab-item value="sabores">
                <v-container>
                    <v-layout>
                        <v-flex>
                            <sp-pizza-flavor :flavors-data="pizza.recheios"></sp-pizza-flavor>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
            <v-tab-item value="configuracao">
                <v-container>
                    <v-layout>
                        <v-flex>
                            <v-radio-group v-model="pizza.config.sum_type">
                                <template v-slot:label>
                                    <div>Considerar nas pizzas com mais de um sabor:</div>
                                </template>
                            <v-radio
                                label="Média dos valores"
                                value="ADD_DIVIDED_PRICE"
                            ></v-radio>
                            <v-radio
                                label="Valor mais alto"
                                value="ADD_DIVIDED_HIGHER_PRICE"
                            ></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex class="text-xs-right">
                            <v-btn color="success" @click="save" :loading="loading">Salvar</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12>
                            <span class="v-label theme--light">Horário de funcionamento para Pizzas:</span>
                            <v-switch
                            class="mt-1"
                            v-model="horarioFuncionamento"
                            label="Usar horário personalizado"
                            ></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap v-if="horarioFuncionamento">
                        <v-flex xs12 xl6 v-for="day in days" :key="day.name">
                            <v-list class="transparent">
                                <v-subheader class="title">{{day.name}}</v-subheader>
                                <v-list-tile v-if="day.ranges.length==0">
                                    <span class="subheading grey--text">fechado</span>
                                    <v-list-tile-action>
                                        <v-btn flat small color="accent" @click="day.ranges.push({start:null,end:null})">
                                            alterar
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <sp-ranger-picker
                                    v-for="(range, index) in day.ranges" :key="index"
                                    v-model="day.ranges[index]" @delete="day.ranges.splice(index,1)"
                                >
                                </sp-ranger-picker>
                                <v-list-tile>
                                    <v-btn flat color="accent" @click="day.ranges.push({start:null,end:null})"
                                        v-if="day.ranges.length >= 1"
                                    >
                                        Adicionar outros horários de funcionamento
                                    </v-btn>
                                </v-list-tile>
                                <v-divider></v-divider>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
        </v-tabs-items>
    </v-flex>
</v-layout>
</template>

<script>
import SpPizzaSize from '../components/SpPizzaSize'
import SpPizzaDough from "../components/SpPizzaDough";
import SpPizzaEdge from "../components/SpPizzaEdge";
import SpPizzaFlavor from "../components/SpPizzaFlavor";
import SpRangerPicker from "../components/SpRangerPicker";
import {mapGetters} from 'vuex'

export default {
    data(){
        return {
            button:null,
            tab:"tamanhos",
            loading:false,
            flavorSetting:1,
            days:[
                {name:"Domingo",ranges:[]},
                {name:"Segunda-feira",ranges:[]},
                {name:"Terça-feira",ranges:[]},
                {name:"Quarta-feira",ranges:[]},
                {name:"Quinta-feira",ranges:[]},
                {name:"Sexta-feira",ranges:[]},
                {name:"Sábado",ranges:[]},
            ],
            daysDefault:[
                {name:"Domingo",ranges:[]},
                {name:"Segunda-feira",ranges:[]},
                {name:"Terça-feira",ranges:[]},
                {name:"Quarta-feira",ranges:[]},
                {name:"Quinta-feira",ranges:[]},
                {name:"Sexta-feira",ranges:[]},
                {name:"Sábado",ranges:[]},
            ],
            horarioFuncionamento:false
        }
    },
    components:{
        SpPizzaSize,
        SpPizzaDough,
        SpPizzaEdge,
        SpPizzaFlavor,
        SpRangerPicker
    },
    mounted(){
        this.convertRanges(this.pizza.config.pizzaria_horario)
    },
    watch:{
        pizza(v){
            this.convertRanges(v)
        }
    },
    computed: {
        ...mapGetters([
            'pizza',
            'restaurant'
        ]),
        productDialog:{
            get(){
                return this.$store.state.productDialog
            },
            set(v){
                this.$store.state.productDialog = v
            }
        },
        search:{
            get(){
                return this.$store.state.search
            },
            set(value){
                if(!value)value=''
                return this.$store.state.search = value
            }
        },
    },
    methods:{
        convertRanges(v){
            let ranges
            if(this.pizza.config.pizzaria_horario.length > 0){
                this.horarioFuncionamento = true
                ranges = v
            }else{
                ranges = this.restaurant.horario_funcionamento
            }
            this.days = JSON.parse(JSON.stringify(this.daysDefault))
            ranges.forEach(range => {
                if(range.dia1 != undefined){
                    let start
                    let end
                    if(range.dia1 < range.dia2){
                        start = range.dia1
                        end = range.dia2
                    }else{
                        start = range.dia2
                        end = range.dia1
                    }
                    for(let i=start;i<=end;i++){
                        this.days[i].ranges.push({start:range.hora1,end:range.hora2})
                    }
                }else{
                    this.days[range.dia2].ranges.push({start:range.hora1,end:range.hora2})
                }
            });
        },
        deleteRange(index,day){
            day.ranges.splice(index,1)
        },
        setRange(start,end,index,day){
            day.ranges[index] = {start,end}
        },
        searchAction(){
            if(this.search && this.search.trim().length >= 3 || this.search.trim().length == 0 ){
                this.$store.dispatch('fetchProducts')
                this.$store.dispatch('fetchMenu')
            }
        },
        price(v){
            return 'R$' + Number(v).toFixed(2).toString().replace('.',',')
        },
        save(){
            this.loading = true
            const data = {
                sum_type:this.pizza.config.sum_type,
                pizzaria_horario:[]
            }
            if(this.horarioFuncionamento == true){
                this.days.forEach((day,index) => {
                    day.ranges.forEach(range => {
                        if(range.start && range.end){
                            data.pizzaria_horario.push({
                                dia2:index,
                                hora1:range.start,
                                hora2:range.end
                            })
                        }
                    });
                });
            }
            this.loading = false
            this.$store.dispatch('updatePizzaConfig',data).then(res=>{
                this.loading = false
            }).catch(err=>{
                this.error = err
                console.log(err)
                this.loading = false
            })
        }
    }
}
</script>